'use client';
import { useMe } from '../client-auth/use-me';
import { useEffect } from 'react';
import { analytics } from './segment';

export function Identify() {
  const authStatus = useMe();

  if (!authStatus.user) {
    return null;
  }

  useEffect(() => {
    analytics.identify(authStatus.user?.user_id, {
      name: authStatus.user?.fullName,
      email: authStatus.user?.email,
    });
  }, []);

  return null;
}
